import RemoteResourceRepository from './RemoteResourceRepository'

/*
 * RemoteSettingRepository is a simple implementation of the RemoteResourceRepository
*/
export default class RemoteSettingRepository extends RemoteResourceRepository {
  constructor () {
    super('setting')
  }
}
